import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { GEOGRAPHY_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_ZONE_LIST = '_LOAD_ZONE_LIST';
export const CREATE_ZONE = '_CREATE_ZONE';
export const LOAD_ZONE_BY_ID = '_LOAD_ZONE_BY_ID';
export const EDIT_ZONE_BY_ID = '_EDIT_ZONE_BY_ID';
export const DELETE_ZONE = '_DELETE_ZONE';
export const EXPORT_GEOGRAPHY = '_EXPORT_GEOGRAPHY';
export const IMPORT_GEOGRAPHY = '_IMPORT_GEOGRAPHY';
export const LOAD_ZONE_HISTORY = '_LOAD_ZONE_HISTORY';
export const LOAD_HISTORY_BY_ID = '_LOAD_HISTORY_BY_ID';

export const loadGeographyList = createDeferredAction(GEOGRAPHY_MODULE + LOAD_ZONE_LIST);
export const loadGeographyListBegin = createDeferredAction(GEOGRAPHY_MODULE + LOAD_ZONE_LIST + BEGIN);
export const loadGeographyListSuccessful = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_LIST + SUCCESSFUL);
export const loadGeographyListFailed = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_LIST + FAILED);

export const createGeography = createDeferredAction(GEOGRAPHY_MODULE + CREATE_ZONE);
export const createGeographySuccessful = createAction(GEOGRAPHY_MODULE + CREATE_ZONE + SUCCESSFUL);
export const createGeographyFailed = createAction(GEOGRAPHY_MODULE + CREATE_ZONE + FAILED);

export const loadGeographyById = createDeferredAction(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID);
export const loadGeographyByIdSuccessful = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID + SUCCESSFUL);
export const loadGeographyByIdFailed = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID + FAILED);
export const loadGeographyByIdClear = createDeferredAction(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID + CLEAR);

export const editGeographyById = createDeferredAction(GEOGRAPHY_MODULE + EDIT_ZONE_BY_ID);
export const editGeographyByIdSuccessful = createAction(GEOGRAPHY_MODULE + EDIT_ZONE_BY_ID + SUCCESSFUL);
export const editGeographyByIdFailed = createAction(GEOGRAPHY_MODULE + EDIT_ZONE_BY_ID + FAILED);

export const deleteGeography = createDeferredAction(GEOGRAPHY_MODULE + DELETE_ZONE);
export const deleteGeographySuccessful = createAction(GEOGRAPHY_MODULE + DELETE_ZONE + SUCCESSFUL);
export const deleteGeographyFailed = createAction(GEOGRAPHY_MODULE + DELETE_ZONE + FAILED);

export const exportGeography = createDeferredAction(GEOGRAPHY_MODULE + EXPORT_GEOGRAPHY);
export const exportGeographySuccessful = createAction(GEOGRAPHY_MODULE + EXPORT_GEOGRAPHY + SUCCESSFUL);
export const exportGeographyFailed = createAction(GEOGRAPHY_MODULE + EXPORT_GEOGRAPHY + FAILED);

export const importGeography = createDeferredAction(GEOGRAPHY_MODULE + IMPORT_GEOGRAPHY);
export const importGeographySuccessful = createAction(GEOGRAPHY_MODULE + IMPORT_GEOGRAPHY + SUCCESSFUL);
export const importGeographyFailed = createAction(GEOGRAPHY_MODULE + IMPORT_GEOGRAPHY + FAILED);

export const loadGeographyHistory = createDeferredAction(GEOGRAPHY_MODULE + LOAD_ZONE_HISTORY);
export const loadGeographyHistorySuccessful = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_HISTORY + SUCCESSFUL);
export const loadGeographyHistoryFailed = createAction(GEOGRAPHY_MODULE + LOAD_ZONE_HISTORY + FAILED);

export const loadHistoryById = createDeferredAction(GEOGRAPHY_MODULE + LOAD_HISTORY_BY_ID);
export const loadHistoryByIdSuccessful = createAction(GEOGRAPHY_MODULE + LOAD_HISTORY_BY_ID + SUCCESSFUL);
export const loadHistoryByIdFailed = createAction(GEOGRAPHY_MODULE + LOAD_HISTORY_BY_ID + FAILED);
